import CollectMarketingCommunicationPreferences from ".";

export default function CollectMarketingCommunicationPreferencesExamples() {
  function onSubmit() {
    console.log("onSubmit");
  }

  return (
    <>
      <CollectMarketingCommunicationPreferences
        phoneNumber="600001001"
        onSubmit={onSubmit}
      />
    </>
  );
}
